import { css } from '@emotion/core';

import colors from '../config/colors';
import { desktopMediaQuery, mobileMediaQuery } from '../config/mediaQuery';

// group panel height
const groupPanelHeight = 65;
const controlsHeight = groupPanelHeight;

const grid = css`
  /**
    * will take care of placing the last dialog opened on top of the other.
    */
  .modal-open > [role='dialog']:last-child {
    z-index: 1051;
    position: absolute;
    width: 100vw;
    height: 100vh;
  }

  .wj-cell {
    padding: 1px;
    height: 22px;
    font-size: 0.9em;
  }

  .wj-flexgrid {
    height: auto;
    background-color: ${colors.veryLightBlue};
  }

  .wj-flexgrid .wj-group:not(.wj-state-selected):not(.wj-state-multi-selected) {
    font-weight: bold;
    font-size: 1.05em;
  }

  .wj-groupmarker {
    height: auto;
    width: auto;
  }

  // Target column headers.
  div > .wj-colheaders > .wj-row > .wj-header.wj-cell {
    font-size: 0.9em;
  }

  // Target footer total row.
  div > .wj-colfooters > .wj-row > .wj-header.wj-cell {
    font-size: 1.05em;
  }

  .wj-grouppanel {
    height: ${groupPanelHeight}px;
  }

  .wj-grouppanel > div {
    display: flex;
    align-items: center;
  }

  .wj-aggregate-row {
    background-color: ${colors.lightYellow} !important;
    font-weight: bold;
  }

  .page--is-full-page .wj-flexgrid {
    /* TODO: check if there is a way to make this dynamic. This is
    * Header + Nav + Pagination
    */
    height: 100%;
  }

  .page--is-full-page.page--with-group-panel .wj-flexgrid {
    height: calc(100% - ${controlsHeight}px);
  }

  .page--is-nested .wj-flexgrid {
    height: 600px;
  }

  .page--is-nested.page--with-group-panel .wj-flexgrid {
    height: calc(600px - ${controlsHeight}px);
  }

  .page--size-small .wj-flexgrid {
    height: 300px;
  }

  .page--is-nested.page--with-group-panel .wj-flexgrid {
    height: calc(300px - ${controlsHeight}px);
  }

  .wj-flexgrid * {
    /*
    * from time to time it shows the ring in unexpected places
    * making the grid look a bit weird.
    */
    outline: none;
  }

  /**
    * bug introduced in 5.20182.524 where the color is too similar to
    * the background-color
    */
  .wj-state-selected {
    color: white !important;
  }

  div[wj-part='ch'],
  div[wj-part='rh'] {
    background-color: ${colors.lightGray};
  }

  /*
  * we need to make use of #root to beat the specificity
  * of .wj-alt:not(.wj-header):not(.wj-group):not(.wj-state-selected):not(.wj-state-multi-selected)
  * and at the same time, leave room for overwriting these styles when needed.
  */
  #root .yellow {
    background-color: ${colors.yellow};
  }

  #root .orange {
    background-color: ${colors.orange};
  }

  #root .red {
    background-color: ${colors.red};
  }

  #root .green {
    background-color: ${colors.green};
  }

  #root .gray {
    background-color: ${colors.gray};
  }

  #root .lightGreen {
    background-color: ${colors.lightGreen};
  }

  #root .lightYellow {
    background-color: ${colors.lightYellow};
  }

  #root .lightRed {
    background-color: ${colors.lightRed};
  }

  /*
  * These styles must overwrite the styles above. These appear when the user
  * selects one or more rows/columns.
  */
  .wj-state-selected {
    background-color: ${colors.blue} !important;
    color: ${colors.white};
  }

  .wj-state-multi-selected {
    background-color: ${colors.blueGray} !important;
    color: ${colors.white};
  }

  .modal-open .modal-dialog.modal-lg {
    width: 90%;
  }

  ${desktopMediaQuery} {
    .modal-open .modal-dialog {
      width: 80%;
    }
  }

  .modal-open .modal--form .modal-dialog {
    max-width: 700px;
  }

  /*
    * To make sure notifications are always on top
    */
  .Toastify {
    position: relative;
    z-index: 999999;
  }

  ${mobileMediaQuery} {
    .wj-flexgrid .wj-glyph-filter {
      width: 11px;
    }
  
    .wj-flexgrid .wj-glyph-filter:after {
      height: 10px;
      left: 0px;
    }
  
    .wj-flexgrid .wj-cell .wj-btn.wj-btn-glyph {
      min-width: 30px;
    }
  }
`;

export { grid };
